<template>
  <card class="card" title=""><br />
    <div class="row">
      <div class="col-md-4">
        <label>Busqueda</label>
        <div class="input-group mb-3">
          <input type="text" class="form-control" placeholder="Buscar ..." v-model="word" />
          <div class="input-group-append">
            <button class="btn btn-info" type="info" @click="() => { page = 1; getBackupTask() }">
              <i class="material-icons white-text">search</i>
            </button>
          </div>
        </div>
      </div>
      <div class="col-md-6">
      <label :hidden="hidden">Estaciones</label>
        <div class="d-flex">
          <vSelect
            :options="stations"
            placeholder="Selecciona..."
            v-model="stationId"
            style="width: 100%"
            :hidden="hidden"
            v-on:input="() => { page = 1; getBackupTask() }"
          />
        </div>
      </div>
      <div class="col-md-2" :style="{ paddingRight: '33px' }" title="Agregar">
      <br/>
        <div class="d-flex justify-content-end">
          <button class="btn btn-success" type="info" @click="() => { this.$router.push('/crear-tareas-estacion') }">
            <i class="material-icons white-text">add</i>
          </button>
        </div>
      </div>
    </div>

    <div class="table-responsive">
      <div class="col-md-12">
        <table class="table table-striped">
          <thead class="table-dark">
            <tr>
              <th v-for="col in headers" :key="col.label">{{ col.label }}</th>
            </tr>
          </thead>
          <tbody v-if="content.length > 0">
            <tr v-for="(bt) in content" :key="bt.id">
              <td>{{ bt.path }}</td>
              <td>{{ formatDate(bt.start_date) }}</td>
              <td>{{ bt.format }}</td>
              <td>{{ bt.type }}</td>
              <td>{{ bt.period }}</td>
              <td>
                <i class="material-icons white-text" :style="{ cursor: 'pointer', color: 'red' }"
                  @click="() => deleteItem(bt.id, bt.station)" title="Eliminar">
                  delete
                </i>
                <i class="material-icons white-text" :style="{ cursor: 'pointer', color: '#17a2b8' }"
                  @click="() => modifyItem(bt.id)" title="Modificar">
                  edit
                </i>
              </td>
            </tr>
          </tbody>
          <tbody v-else>
            <tr>
              <td colspan="6" style="background-color:#eee;">
              <center> Información no encontrada </center>
            </td>
            </tr>
          </tbody>

        </table>
        <div v-if="content.length > 0">
          <p class="text-right" :style="{ paddingRight: '11px' }" v-if="count > (page * 5)">
            {{ ((page - 1) * 5) + 1 }} - {{ page * 5 }} de {{ count }} registros
          </p>
          <p class="text-right" :style="{ paddingRight: '11px' }" v-else>
            {{ ((page - 1) * 5) + 1 }} - {{ count }} de {{ count }} registros
          </p><br />
        </div>
        <div v-else> </div>
      </div><br/>

      <div class="d-flex justify-content-center">
        <b-pagination v-model="page" :total-rows="count" prev-text="Anterior" next-text="Siguiente" :per-page="5"
          @change="handlePageChange" />
      </div>
    </div>
  </card>
</template>

<script>
import backupTaskService from '../../services/backupTaskService';
import state from "../../store/state";
import store from "../../store";
import vSelect from "vue-select";
import moment from 'moment';

export default {
  components: {
    vSelect
  },
  name: "backupTask",
  data() {
    return {
      headers: [],
      content: [],
      currentStation: null,
      currentIndex: -1,
      word: "",
      page: 1,
      count: 0,
      stationId: null,
      stations: [],
      hidden:
        localStorage.getItem('role') === 'ADMIN' ||
        localStorage.getItem('role') === 'SUPPORT' ? false : true,
    };
  },
  methods: {
    getRequestParams(page, word, stationId) {
      let params = {};

      if (page) {
        params["page"] = page - 1;
      }

      if (word) {
        params["word"] = word;
      }

      if (stationId) {
        params["stationId"] = stationId;
      }

      return params;
    },

    async getBackupTask() {
      const params = this.getRequestParams(
        this.page,
        this.word ? this.word : null,
        this.stationId
      );
      const backupTask = await backupTaskService.getBackupTask(params.page, this.word, this.stationId);
      const { content } = await backupTask.data.data;
      const { totalElements } = await backupTask.data.data;
      this.count = totalElements;
      this.content = content;
    },

    handlePageChange(value) {
      this.page = value;
      this.getBackupTask();
    },

    refreshList() {
      this.getBackupTask();
      this.currentStation = null;
      this.currentIndex = -1;
    },

    setActiveStation(station, index) {
      this.currentStation = station;
      this.currentIndex = index;
    },

    deleteItem(id) {
      swal({
        title: '¡Aviso!',
        text: '¿Eliminar registro?',
        icon: 'warning',
        buttons: true,
      }).then((result) => {
        if (result) {
          backupTaskService.delete(id).then(response => {
            if (response.data.error === false) {
              swal({
                title: 'Exitoso',
                text: 'Se elimino la tarea correctamente',
                icon: 'success',
                timer: 3000,
                buttons: false
              })
              setTimeout(() => {
                window.location.reload()
              }, 3000)
            } else {
              swal({
                title: '¡Algo salio mal!',
                text: 'Consulte con el administrador',
                icon: 'warning',
                timer: 3000,
                buttons: false
              })
            }
          })
        }
      })
    },

    modifyItem(id) {
      this.$router.push("/editar-tareas-estacion/" + id);
    },

    formatDate ( date ) {
      const d = date.toString().split('T')
      return d[0]
    }


  },
  beforeCreate() {
    store.dispatch('actionGetStations');
  },
  mounted() {
    this.getBackupTask();
    this.content = state.tasks.list;
    this.headers = state.tasks.headers;
    this.stations = []
    
    if(
      localStorage.getItem('stationsJSON') &&
      JSON.parse(localStorage.getItem('stationsJSON')).length > 0
    ) {
        this.stations = localStorage.getItem('stationsJSON') 
          ? JSON.parse(localStorage.getItem('stationsJSON')) : []
    } else {
      setTimeout(() => {
        this.stations = state.stations.select
      }, 2000)
    }
  },
};
</script>

<style>
.list {
  text-align: left;
  max-width: 750px;
  margin: auto;
}
.material-icons {
  line-height: 0.6 !important;
}
</style>
